import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';

import {
  hasProviderProfileSelector,
  loggedUserSelector,
  selectIsLoggedTeam,
} from '../../redux/context/selectors';
import { selectCaregiverCircleList } from '../../redux/circles/selectors';
import { selectGuardianDependentsList } from '../../redux/profiles/selectors';
import { selectPracticeProviders } from '../../redux/schedule/selectors';
import { STATUS_DEPENDENT_VERIFIED } from '../../constants';

function userFormatter(list = []) {
  return list.map(item => ({
    ...item.dependent,
    status: item.status,
  }));
}

export function useCareUsers(withVerifiedUser) {
  const isProvider = useSelector(hasProviderProfileSelector);
  const isTeam = useSelector(selectIsLoggedTeam);
  const loggedUser = useSelector(loggedUserSelector);
  const caregiverCircle = useSelector(selectCaregiverCircleList);
  const practiceProviders = useSelector(selectPracticeProviders);
  const guardianCircle = userFormatter(
    useSelector(selectGuardianDependentsList),
  );

  const safeCaregiverCircle = withVerifiedUser
    ? caregiverCircle.filter(
        ({ status }) => status === STATUS_DEPENDENT_VERIFIED,
      )
    : caregiverCircle;

  const safeGuardianCircle = withVerifiedUser
    ? guardianCircle.filter(
        ({ status }) => status === STATUS_DEPENDENT_VERIFIED,
      )
    : guardianCircle;

  const makeNavList = useCallback(
    formatMessage => {
      const list = isTeam
        ? []
        : [{ title: '', list: [loggedUser], key: 'loggedUser' }];

      if (isProvider) {
        const providerList = practiceProviders.map(item => ({
          ...item,
          calendarManageable: true,
        }));

        if (!isEmpty(providerList)) {
          list.push({
            title: formatMessage({ id: 'healthboard.providersNavTitle' }),
            list: providerList,
            key: 'providerCircle',
          });
        }

        return list;
      }

      if (!isEmpty(safeGuardianCircle)) {
        list.push({
          title: formatMessage({ id: 'circles.titles.guardianFor' }),
          list: safeGuardianCircle,
          key: 'guardianCircle',
        });
      }

      if (!isEmpty(safeCaregiverCircle)) {
        list.push({
          title: formatMessage({ id: 'circles.titles.listCaregiver' }),
          list: safeCaregiverCircle,
          key: 'caregiverCircle',
        });
      }

      return list;
    },
    [
      loggedUser,
      caregiverCircle,
      guardianCircle,
      isProvider,
      practiceProviders,
      isTeam,
      withVerifiedUser,
    ],
  );

  const getTargetUser = useCallback(
    userId =>
      [loggedUser, ...caregiverCircle, ...guardianCircle].find(
        ({ id }) => userId === id,
      ),
    [loggedUser, caregiverCircle, guardianCircle],
  );

  return {
    getTargetUser,
    makeNavList,
    isTeam,
  };
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/useCareUsers.js